import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTabsContext } from '../util';

export function useShowScrollButtons(): [
  boolean,
  Dispatch<SetStateAction<HTMLDivElement | null>>,
] {
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const controller = useTabsContext();

  useEffect(() => {
    if (ref && controller) {
      const observer = new MutationObserver(([{ addedNodes }]) => {
        const fixedTabsElement = ref.querySelector('.tabsList__fixedTabs');
        const hasFixedTabsScroll =
          (fixedTabsElement?.clientWidth ?? 0) <
          (fixedTabsElement?.scrollWidth ?? 0);
        const nonFixedTabsElement = ref.querySelector('.tabs__list');
        const hasFixedNonTabsScroll =
          (nonFixedTabsElement?.clientWidth ?? 0) <
          (nonFixedTabsElement?.scrollWidth ?? 0);

        setShowScrollButtons(hasFixedTabsScroll || hasFixedNonTabsScroll);

        if (addedNodes) {
          (ref.querySelector('.tabs__list') as HTMLElement).scrollLeft =
            9999999;
        }
      });
      observer.observe(ref, { childList: true, subtree: true });
      return () => {
        observer.disconnect();
      };
    }

    return () => {};
  }, [controller, ref]);

  return [showScrollButtons, setRef];
}
